import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import { SalesService } from '../../../../services/sales.service';
import { Product, RecentInteractions, SalesOrder, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import _ from 'lodash';
import { LoaderComponent } from '../../../loader/loader.component';
import { ReportLookupComponent } from '../../../Reports/report-lookup/report-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { CustomerService } from '../../../../services/customer.service';
import { catchError, firstValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { ReportCenterService } from '../../../../services/report-center.service';
import { InventoryService } from '../../../../services/inventory.service';
import { AdministratorService } from '../../../../services/administrator.service';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';


@Component({
  selector: 'app-list-quote',
  standalone: true,
  imports: [SharedModule,CommonModule, LoaderComponent],
  templateUrl: './list-quote.component.html',
  styleUrl: './list-quote.component.scss'
})
export class ListQuoteComponent implements OnInit{
  @ViewChild('dt1') dt1: Table | undefined;
  paginator: boolean | undefined;

  constructor(private router: Router, private salesService: SalesService, private confirmationService: ConfirmationService, private customerService: CustomerService, private inventoryService: InventoryService, private administratorService: AdministratorService,
    private messageService: MessageService, public dialogService: DialogService, public ref: DynamicDialogRef, private emailTemplateService: EmailTemplateService, private reportService: ReportCenterService, private porderservice: PurchaseorderService) { }

  visible: boolean = false;
  loader: boolean = false;
  searchKey: any;
  listQuotes: SalesOrder[] = [];
  selectedQuote: SalesOrder[] = [];
  Data: any;
  companyInfo: any = {};
  ReportPath: any;
  OrderNumber: any;
  Status: any;
  products: Product[] = [];    
  allProductData: Product[] = [];
  pageRequest: gridPageRequest = {
    pageIndex:0,
    pageSize: 50,
    id: 0
  }

  ngOnInit(): void {
    document.title = 'Quote List';
    this.getQuoteList();
    this.getCompanyDetails();
    this.searchEffect();
  }

  create() {
    this.router.navigate(['/home/createQuotes']);
  }

  loadQuoteList(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchQuote();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getQuoteList();
    }
  }

  getQuoteList() {
    // this.loader = true;
    this.salesService.getSalesOrderByStatus('QUOTE', this.pageRequest).subscribe(
      (data: any) => {
        if (data) {
          this.listQuotes = data.salesOrder;
          // this.loader = false;
        } else {
          console.log(data);
          // this.loader = false;
        }
      },
      (error: any) => {
        console.log(error);
        // this.loader = false;
      }
    );
  }


  editQuote(data?: any) {
    if (data) {
      // const Data = JSON.stringify(data);
      this.router.navigate(['/home/createQuotes'], { queryParams: { 'Data': data.salesOrderId }, skipLocationChange: false, });
    } else {
      const Data = JSON.stringify(this.selectedQuote[0].salesOrderId);
      // console.log(Data);
      this.router.navigate(['/home/createQuotes'], { queryParams: { 'Data': Data }, skipLocationChange: false, });
    }
  }

async deleteQuote() {
  this.confirmationService.confirm({
    header: 'Are you sure?',
    message: 'Please confirm to proceed.',
    accept: async () => {
      this.loader = true;

      try {
        const deleteTasks = this.selectedQuote.map(async (quoteRaw) => {
          const quote: SalesOrder = this.mapToSalesOrder(quoteRaw);
          const salesOrderId = quote.salesOrderId;
          const salesOrderNumber = quote.SalesOrderNumber;
          const warehouseId = quote.WarehouseId;

          let lineItemData: any[] = [];
          try {
            lineItemData = await firstValueFrom(
              this.salesService.getSalesOrderLineItem(salesOrderNumber)
            );
          } catch (err) {
            console.error(`Failed to get line items for ${salesOrderNumber}:`, err);
          }

          try {
            await firstValueFrom(this.salesService.deleteSalesOrder([salesOrderId]));
          } catch (delErr) {
            console.error(`Failed to delete order ${salesOrderNumber}:`, delErr);
            return; 
          }

          try {
            const lineItemIds = lineItemData.map(item => item.salesOrderLineItemId);
            if (lineItemIds.length) {
              await firstValueFrom(this.salesService.deleteSalesOrderLineItem(lineItemIds));
            }
          } catch (err) {
            console.error(`Failed to delete line items for ${salesOrderNumber}:`, err);
          }

          const inventoryTasks = lineItemData.map(product => {
            const inventory: UpdateInventory = {
              productId: product.productId,
              warehouseId: _.toNumber(warehouseId),
              productCode: product.productCode,
              status: "DELETEQUOTE",
              transactionNo: salesOrderNumber,
              transactionType: "DELETEQUOTE",
              quantity: product.quotedQuantity || 0,
              createdBy: localStorage.getItem('username')!,
              transactionDate: new Date(),
              createdDate: new Date(),
            };
            return firstValueFrom(this.inventoryService.updateInventoryNew(inventory));
          });

          try {
            await Promise.all(inventoryTasks);
          } catch (invErr) {
            console.error(`Inventory update failed for order ${salesOrderNumber}:`, invErr);
          }
        });

        await Promise.all(deleteTasks);
        this.products = [];
        this.allProductData = [];

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Deleted successfully.'
        });

        this.selectedQuote = [];
        this.searchKey = '';
        this.paginator = true;
        this.pageRequest.pageIndex = 0;
        this.pageRequest.pageSize = 50;

        if (this.dt1) {
          this.dt1.first = 0;
        }

        await this.getQuoteList();
      } catch (error) {
        console.error('Unexpected error during deleteQuote:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete selected quotes.'
        });
      } finally {
        this.loader = false;
      }
    },
    reject: () => {
      // User cancelled
    }
  });
}

  mapToSalesOrder(order: any): SalesOrder {
    return {
      salesOrderId: order.salesOrderId,
      SalesOrderNumber: order.salesOrderNumber || order.SalesOrderNumber,
      OrderType: order.orderType || order.OrderType,
      CustomerId: order.customerId?.toString() || order.CustomerId,
      SalesOrderDate: new Date(order.salesOrderDate || order.SalesOrderDate),
      SalesOrderInvoiceDate: new Date(order.salesOrderInvoiceDate || order.SalesOrderInvoiceDate || new Date()),
      ShipmentDate: new Date(order.shipmentDate || order.ShipmentDate || new Date()),
      SalespersonId: order.salespersonId?.toString() || order.SalespersonId,
      SalespersonCode: order.salespersonCode || order.SalespersonCode,
      BillToCustomerId: order.billToCustomerId?.toString() || order.BillToCustomerId,
      ShipToCustomerId: order.shipToCustomerId?.toString() || order.ShipToCustomerId,
      BillToCustomerCode: order.billToCustomerCode || order.BillToCustomerCode,
      ShipToCustomerCode: order.shipToCustomerCode || order.ShipToCustomerCode,
      QuoteExpiration: order.quoteExpiration ? new Date(order.quoteExpiration) : new Date(),
      WarehouseId: order.warehouseId?.toString() || order.WarehouseId,
      PurchaseOrderNumber: order.purchaseOrderNumber || order.PurchaseOrderNumber,
      OrderTotal: order.orderTotal || order.OrderTotal,
      CGSTTotal: order.cgstTotal || order.CGSTTotal,
      SGSTTotal: order.sgstTotal || order.SGSTTotal,
      IGSTTotal: order.igstTotal || order.IGSTTotal,
      totalWeight: order.totalWeight || order.totalWeight,
      DispatchDocNo: order.dispatchDocNo || order.DispatchDocNo,
      ShippingStatus: order.shippingStatus || order.ShippingStatus,
      SalesOrderStatus: order.salesOrderStatus || order.SalesOrderStatus,
      BackOrderStatus: order.backOrderStatus || order.BackOrderStatus,
      SalesTaxTotal: order.salesTaxTotal || order.SalesTaxTotal,
      MarginTotal: order.marginTotal || order.MarginTotal,
      ProfitTotal: order.profitTotal || order.ProfitTotal,
      LabourTotal: order.labourTotal || order.LabourTotal,
      FreightTotal: order.freightTotal || order.FreightTotal,
      IsGlPosted: order.isGlPosted || order.IsGlPosted,
      InvoiceYear: order.invoiceYear || order.InvoiceYear,
      InvoiceMonth: order.invoiceMonth || order.InvoiceMonth,
      BackOrderTotal: order.backOrderTotal || order.BackOrderTotal,
      GLError: order.glError || order.GLError,
      IsLabourTaxable: order.isLabourTaxable || order.IsLabourTaxable,
      IsFreightTaxable: order.isFreightTaxable || order.IsFreightTaxable,
      IsActive: order.isActive || order.IsActive,
      CreatedBy: order.createdBy || order.CreatedBy,
      UpdatedBy: order.updatedBy || order.UpdatedBy,
      TermsCode: order.termsCode || order.TermsCode,
      PaymentTermsId: order.paymentTermsId || order.PaymentTermsId,
      MotorVehicleNo: order.motorVehicleNo || order.MotorVehicleNo,
      BillOfLading: order.billOfLading || order.BillOfLading,
      LRRRNo: order.lrrrNo || order.LRRRNo,
      DispatchThrough: order.dispatchThrough || order.DispatchThrough,
      orderDate: new Date(order.orderDate || order.orderDate),
      requestedDate: new Date(order.requestedDate || order.requestedDate),
      deliveryNote: order.deliveryNote || order.DeliveryNote,
      ServiceCallCode: order.serviceCallCode || order.ServiceCallCode,
      ReferenceNumber: order.referenceNumber || order.ReferenceNumber,
      Destination: order.destination || order.Destination,
      TermsOfDelivery: order.termsOfDelivery || order.TermsOfDelivery,
      Status: order.status || order.Status,
      CustomerPODate:  order.customerPODate ? new Date(order.customerPODate) : new Date(),
      driverName: order.driverName,
      driverContact: order.driverContact,
      expDeliveryDate:  order.expDeliveryDate ? new Date(order.expDeliveryDate) : new Date(),
    };
  };

  searchQuote() {
    if (!this.searchKey) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please enter a search keyword' });
      return;
    }

    // this.loader = true;

    this.salesService.SearchSalesOrder(this.searchKey).subscribe(
      (data: any) => {
        if (Array.isArray(data)) {
          this.listQuotes = data.filter((quote: any) => quote.salesOrderStatus === 'QUOTE');
          this.pageRequest.pageSize = this.listQuotes.length;
          this.paginator = false;
        }
        else if (data && Array.isArray(data.salesOrder)) {
          this.listQuotes = data.salesOrder.filter((quote: any) => quote.salesOrderStatus === 'QUOTE');
          this.pageRequest.pageSize = this.listQuotes.length;
          this.paginator = false;
        }
        else {
          this.listQuotes = [];
        }

        // this.loader = false;
      },
      (error) => {
        console.error('Search error:', error);
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch data' });
      }
    );
  }


 showReport(value: any): void {
  const formCode = 'Quote';

  this.reportService.getReportName(formCode).subscribe({
    next: (report: any) => {
      const salesOrderNumber = value.salesOrderNumber;
      const sanitizedOrderNumber = salesOrderNumber.replace(/[^a-zA-Z0-9]/g, "_");
      document.title = sanitizedOrderNumber;
      this.ref = this.dialogService.open(ReportLookupComponent, {
        header: report.formName,
        width: '100%',
        data: {
          OrderNo: salesOrderNumber,
          ReportName: sanitizedOrderNumber,  
          ReportPath: report.path
        }
      });
      this.ref.onClose.subscribe(() => {
        this.searchKey = '';
        document.title = 'Quote List'; 
      });
    },
    error: (err: any) => {
      console.error('Report not found for form code:', formCode, err);
    }
  });
}


  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getQuoteList();
    this.selectedQuote = [];
  }

  sendOrderEmail() {
    if (!this.selectedQuote || this.selectedQuote.length === 0) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select at least one order' });
      return;
    }

    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'Quote';

    this.loader = true;
    let processedCount = 0;
    let successCount = 0;
    let skippedCount = 0;
    const totalOrders = this.selectedQuote.length;

    this.getUserDepartmentName().subscribe(departmentName => {

    this.selectedQuote.forEach(order => {

      this.reportService.getReportName(formCode).pipe(

        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }
          const reportPath = report.path;

          return this.salesService.getSalesOrderById(order.salesOrderId).pipe(
            map(orderData => ({ orderData, reportPath }))
          );
        }),

        switchMap(({ orderData, reportPath }) => {

          if (!orderData?.customer?.email) {
            throw new Error('EMAIL_MISSING');
          }
          return this.customerService.getCustomerById(orderData.shipToCustomerId).pipe(
            map(shipToCustomer => ({ orderData, shipToCustomer, reportPath }))
          );
        }),

        switchMap(({ orderData, shipToCustomer, reportPath }) => {

          return this.emailTemplateService.getTemplate('order-email-template').pipe(
            map(template => {

              if (!template) {
                throw new Error('TEMPLATE_MISSING');
              }

              const formatCurrency = (value: number) =>
                `₹${value.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

              const templateData = {
                customerName: orderData.customer.customerName,
                orderNumber: orderData.salesOrderNumber,
                orderDate: new Date(orderData.orderDate).toLocaleDateString(),
                shipToName: shipToCustomer?.customerName || 'N/A',
                salespersonName: orderData.salesperson.salespersonName,
                salespersonCode: orderData.salesperson.salespersonCode,
                warehouseName: orderData.warehouse.warehouseName,
                orderTotal: formatCurrency(orderData.orderTotal),
                cgstTotal: formatCurrency(orderData.cgstTotal),
                sgstTotal: formatCurrency(orderData.sgstTotal),
                igstTotal: formatCurrency(orderData.igstTotal),
                salesTaxTotal: formatCurrency(orderData.salesTaxTotal),
                currentYear: new Date().getFullYear(),
                companyName: this.companyInfo?.companyName || '',
                companyEmail: this.companyInfo?.companyEmail || '',
                companyPhone: this.companyInfo?.companyPhone || '',
                companyWebsite: this.companyInfo?.companyWebsite || ''
              };
              return {
                orderData,
                emailBody: this.emailTemplateService.replacePlaceholders(template, templateData),
                reportPath
              };
            })
          );
        }),

        switchMap(({ orderData, emailBody, reportPath }) => {

          const emailData = {
            EmailToId: orderData.customer.email,
            EmailToName: orderData.customer.customerName,
            EmailSubject: `Quote ${orderData.salesOrderNumber} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: orderData.salesOrderNumber,
            OrderType: 'SalesOrder',
            TenantId: tenant,
            ReportPath: reportPath,
            DepartmentName: departmentName 
          };

          return this.salesService.SendMail(emailData).pipe(
            map(response => ({
              response,
              orderData
            }))
          );
        }),

        catchError(err => {
          console.error(`Email skipped for Quote ${order.salesOrderId}:`, err.message || err);

          skippedCount++;
          processedCount++;
          if (processedCount === totalOrders) {
            this.loader = false;

            if (successCount === 0) {
              this.messageService.add({
                severity: 'warn',
                summary: 'No Emails Sent',
                detail: 'Quote emails were not sent because required data (report / email / template) was missing.'
              });
            } else if (successCount < totalOrders) {
              this.messageService.add({
                severity: 'warn',
                summary: 'Partial Success',
                detail: `${successCount} quote email(s) sent. ${skippedCount} skipped.`
              });
            } else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Successfully sent ${successCount} quote email(s).`
              });
            }

            this.selectedQuote = [];
          }

          return of(null);
        })


      ).subscribe({
        next: (result) => {
          if (result && result.orderData) {
            successCount++;
            this.createRecentInteractions(result.orderData);
          }

          processedCount++;

          if (processedCount === totalOrders && this.loader) {
            this.loader = false;

            if (successCount === 0) {
              this.messageService.add({
                severity: 'warn',
                summary: 'No Emails Sent',
                detail: 'Quote emails were not sent because required data (report / email / template) was missing.'
              });
            }
            else if (successCount < totalOrders) {
              this.messageService.add({
                severity: 'warn',
                summary: 'Partial Success',
                detail: `${successCount} quote email(s) sent. ${skippedCount} skipped.`
              });
            }
            else {
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail: `Successfully sent ${successCount} quote email(s).`
              });
            }

            this.selectedQuote = [];
          }
        },
        error: () => {
          // Already handled in catchError
        }
      });
    });
   });
  }

  getCompanyDetails() {
    this.administratorService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  
   createRecentInteractions(orderData: any, departmentName: string = '') {
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: 'Send Mail',
          from: fromEmail,
          to: orderData.customer.email,
          subject: `Quote ${orderData.salesOrderNumber || ''} ${orderData.status || ''}`,
          customerNumber: orderData.customer.customerCode,
          description: "Quote Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: res => console.log('Recent interaction created:', res),
          error: err => console.error('Recent interaction error:', err)
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  placeholder: string = 'Search By ';
  private messages: string[] = ['Quote No',	'Order Date',	'Bill TO Customer',	'Ship To Customer',	'Order Total'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.administratorService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }
}
